export const c_table__sticky_cell_InsetInlineEnd = {
  "name": "--pf-v6-c-table__sticky-cell--InsetInlineEnd",
  "value": "0",
  "var": "var(--pf-v6-c-table__sticky-cell--InsetInlineEnd)"
};
export default c_table__sticky_cell_InsetInlineEnd;